module.exports = __webpack_public_path__ + "static/media/ageing.c382c774.jpg";